import { render, staticRenderFns } from "./overallAudit.vue?vue&type=template&id=20d740ce&scoped=true"
import script from "./overallAudit.vue?vue&type=script&lang=js"
export * from "./overallAudit.vue?vue&type=script&lang=js"
import style0 from "./overallAudit.vue?vue&type=style&index=0&id=20d740ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d740ce",
  null
  
)

export default component.exports